
export class WorkTaskGroup {
    constructor() {
        this.groupName = '';
        this.groupOrderKey = 0;
        this.groupVisible = true;
    }

    id?: number;
    groupName?: string;
    groupImage?: string;
    groupOrderKey: number;
    groupVisible: boolean;
}